import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './About.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Banner from '../../components/Banner/Banner';
import innovation from '../../images/about/innovation.png';
import environment from '../../images/about/environment.png';
import social from '../../images/about/social.png';
import transparency from '../../images/about/transparency.png';
import why1 from '../../images/about/about_why1.png';
import why2 from '../../images/about/about_why2.png';
import why3 from '../../images/about/about_why3.png';
import why4 from '../../images/about/about_why4.png';

const About = () => {
  const { t } = useTranslation('about'); // About namespace 사용

  useEffect(() => {
    const section = document.querySelector('.fade-bg-section');

    const handleScroll = () => {
      if (!section) return;
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      // 화면 진입 비율 계산 (0~1)
      const visibleRatio = Math.max(0, Math.min(1, 1 - rect.top / windowHeight));

      // 어둡기 (0.6 → 0)
      const darkness = 0.9 - visibleRatio * 0.9;
      // 블러 (10px → 0px)
      const blurAmount = 15 - visibleRatio * 15;
      // glow 투명도 (0 → 0.4)
      const glowOpacity = visibleRatio * 0.4;
      // glow 번짐 (40px → 120px)
      const glowBlur = 30 + visibleRatio * 40;

      section.style.setProperty('--overlay-opacity', darkness.toFixed(2));
      section.style.setProperty('--overlay-blur', `${blurAmount.toFixed(1)}px`);
      section.style.setProperty('--glow-opacity', glowOpacity.toFixed(2));
      section.style.setProperty('--glow-blur', `${glowBlur.toFixed(1)}px`);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 초기 호출

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Header />
      <div className="Header_Block"></div>
      <div className="About_Section1">
        <div
          data-aos="fade"
          data-aos-easing="ease-out"
          data-aos-duration="1300"
          className="about_section_title"
        >
          <div>Who We Are</div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="500"
          data-aos-easing="ease-out"
          data-aos-duration="1300"
        >
          <div className="about_title">{t('title')}</div>
          <div className="about_title2">{t('title2')}</div>
        </div>
        <div className="scroll-indicator2">
          <div className="arrow2"></div>
        </div>
      </div>
      <div className="About_Section2 fade-bg-section">
        <div>
          <div className="about_vision_mission">
            <div>
              <div
                className="about_section_title2"
                data-aos="fade"
                data-aos-easing="ease-out"
                data-aos-duration="1300"
              >
                <div>Vision</div>
              </div>
              <div
                data-aos="fade-right"
                data-aos-delay="500"
                data-aos-easing="ease-out"
                data-aos-duration="1300"
                className="about_vision"
              >
                {t('vision')}
              </div>
            </div>
            <div>
              <div
                className="about_section_title2"
                data-aos="fade"
                data-aos-easing="ease-out"
                data-aos-duration="1300"
              >
                <div>Mission</div>
              </div>
              <div
                data-aos="fade-left"
                data-aos-delay="500"
                data-aos-easing="ease-out"
                data-aos-duration="1300"
                className="about_mission"
              >
                {t('mission')}
              </div>
            </div>
          </div>
          <div
            data-aos="fade"
            data-aos-easing="ease-out"
            data-aos-duration="1000"
            className="about_title3"
          >
            {t('title3')}
          </div>
        </div>
      </div>
      <div className="About_Section3">
        <div>
          <div
            data-aos="fade"
            data-aos-easing="ease-out"
            data-aos-duration="1300"
            className="about_section_title2"
            style={{ marginBottom: 0 }}
          >
            <div>Core Values</div>
          </div>
          <div className="about_section3_values">
            <div
              data-aos="fade-up"
              data-aos-delay="500"
              data-aos-easing="ease-out"
              data-aos-duration="1300"
              className="core_values"
            >
              <img className="innovation" src={innovation} />
              <div>Innovation</div>
              <div className="about_description">{t('innovation')}</div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="600"
              data-aos-easing="ease-out"
              data-aos-duration="1300"
              className="core_values"
            >
              <img className="innovation" src={environment} />
              <div>Environment</div>
              <div className="about_description">{t('environment')}</div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="700"
              data-aos-easing="ease-out"
              data-aos-duration="1300"
              className="core_values"
            >
              <img className="innovation" src={social} />
              <div>Social</div>
              <div className="about_description">{t('social')}</div>
            </div>
            <div
              data-aos="fade-up"
              data-aos-delay="800"
              data-aos-easing="ease-out"
              data-aos-duration="1300"
              className="core_values"
            >
              <img className="innovation" src={transparency} />
              <div>Transparency</div>
              <div className="about_description">{t('transparency')}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="About_Section4">
        <div
          data-aos="fade"
          data-aos-easing="ease-out"
          data-aos-duration="1300"
          className="about_section_title2"
        >
          <div>Why 4S Mapper?</div>
        </div>

        <div
          data-aos="fade-up"
          data-aos-delay="600"
          data-aos-easing="ease-out"
          data-aos-duration="1000"
          className="why_cards"
        >
          <div className="why_card">
            <div className="why_img">
              <img src={why1} alt="Advanced GeoAI Expertise" />
            </div>
            <div className="why_title">Advanced GeoAI Expertise</div>
            <div className="why_description">{t('desc1')}</div>
          </div>

          <div className="why_card">
            <div className="why_img">
              <img src={why2} alt="Multi-source Data Integration" />
            </div>
            <div className="why_title">Multi-source Data Integration</div>
            <div className="why_description">{t('desc2')}</div>
          </div>

          <div className="why_card">
            <div className="why_img">
              <img src={why3} alt="Automation & Efficiency" />
            </div>
            <div className="why_title">Automation & Efficiency</div>
            <div className="why_description">{t('desc3')}</div>
          </div>

          <div className="why_card">
            <div className="why_img">
              <img src={why4} alt="Future-ready Platform" />
            </div>
            <div className="why_title">Future-ready Platform</div>
            <div className="why_description">{t('desc4')}</div>
          </div>
        </div>
      </div>
      {/* 회사 연혁 */}
      {/* <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          src="./test.html"
          title="Test HTML"
          style={{ width: '100%', height: '100%', border: 'none' }}
        ></iframe>
      </div> */}
      <Footer />
    </>
  );
};

export default About;
